const SKELETON_HEIGHT_XS = 16;

const SKELETON_GAP_XS = 16;

export { SKELETON_GAP_XS, SKELETON_HEIGHT_XS };
